import Loader from './Loader'
export default Loader

export { RichTextAreaGlobalStyle } from './styles'
export { useRichTextAreaActions } from './useRichTextAreaActions'
export { getPhraseContent } from './RichTextToolbar/lib'
